import { t } from 'i18next';
import {
  BOOL,
  HandsUpType,
  MediaSettingType,
  MediaType,
  MeetingSettingsPush,
  UserInfo,
} from '@tencent/wemeet-websdk-next';
import { openToast } from '@component/toast';
import { Modal } from '@tencent/tea-component';
import weMeetClient from '@utils/wemeetClient';

export function handleMeetingSettingsUpdate(data: MeetingSettingsPush, selfInfo: UserInfo) {
  console.log('PUSH MEETING_SETTINGS_UPDATED', data);

  const mediaSettings = data?.media_settings_list?.media_settings ?? [];

  for (const mediaSetting of mediaSettings) {
    // 音频设置
    if (mediaSetting.type === MediaSettingType.UP_AUDIO) {
      if (mediaSetting.mute_all === BOOL.true) {
        if (mediaSetting.allow_unmute_by_self === BOOL.true) {
          openToast(t('主持人已将全体成员静音。'));
        } else {
          openToast(t('主持人已将全体成员静音，并不允许成员自我解除静音。'));
        }
      } else if (mediaSetting.mute_all === BOOL.false) {
        // 如果仍在举手，则先放下手，然后直接开麦不用弹窗询问
        if (selfInfo.handsup === BOOL.true) {
          openToast(t('主持人已解除您的静音。'));
          weMeetClient.mediaCtrl.handsUp(HandsUpType.cancelHandsUp, [MediaType.AUDIO]);
          weMeetClient.mediaCtrl.unMuteAudio({
            requestUpStreamToken: '',
            needRefreshToken: BOOL.false,
          });
          return;
        }

        // (联席)主持人忽略
        if (weMeetClient.userCtrl.isHost() || weMeetClient.userCtrl.isCoHost()) {
          return;
        }

        const messageStyle = {
          fontSize: 16,
          fontWeight: 'normal' as 'normal',
          textAlign: 'center' as 'center',
          lineHeight: '24px',
          marginTop: 40,
          marginBottom: 24,
        };

        Modal.confirm({
          message: <p style={messageStyle}>{t('主持人请求解除您的静音。')}</p>,
          okText: t('保持静音'),
          cancelText: t('解除静音'),
          disableCloseIcon: true,
          size: 's',
          onOk: () => {},
          onCancel: () => {
            weMeetClient.mediaCtrl.unMuteAudio({
              requestUpStreamToken: '',
              needRefreshToken: BOOL.false,
            });
          },
        });
      }
    }
  }
}
